<div class="modal-content">
  <div class="modal-header">
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-edit-veiculo__title">Alterar Veículo</h4>
  </div>

  <div class="modal-body modal-edit-veiculo__body">
    <app-ficha-cadastro-veiculo-info
      [veiculo]="mapVeiculo"
      [veiculos]="mapVeiculos"
      [dontShowButtons]="true"
      [isAlterar]="true"
      (changeForm)="changeForm($event)"
      (changeFormValid)="changeFormValid($event)">
    </app-ficha-cadastro-veiculo-info>
  </div>

  <div class="modal-footer modal-edit-veiculo__footer">
    <button
      type="button"
      class="bt-back btn btn-border-orange"
      (click)="close()">
      Cancelar
    </button>
    <button
      type="button"
      [disabled]="!isVeiculoAlterado || !isFormValid"
      class="bt-back btn btn-full-orange"
      (click)="save()">
      Salvar
    </button>
  </div>
</div>
